import { render, staticRenderFns } from "./CabeceraModalCrear.vue?vue&type=template&id=3b53bfae&"
import script from "./CabeceraModalCrear.vue?vue&type=script&lang=ts&"
export * from "./CabeceraModalCrear.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3b53bfae', component.options)
    } else {
      api.reload('3b53bfae', component.options)
    }
    module.hot.accept("./CabeceraModalCrear.vue?vue&type=template&id=3b53bfae&", function () {
      api.rerender('3b53bfae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/Modal/CabeceraModalCrear.vue"
export default component.exports